import React from 'react';
import { useNavigate, useParams, useHistory } from 'react-router-dom';

import Company from "api/Company";

import CompanyModel from 'models/Company';
import { connect } from "react-redux";
import {CompanyAdd} from 'views/company/Add';
import {
  MESSAGE_SUCCES,
	MESSAGE_INFO,
	MESSAGE_ERROR,
	SET_COMPANY
} from "actions/types";
import {showLoader,hideLoader} from "actions/types";
import { messageActions } from 'redux/messageSlice';
import messageSlice from 'redux/messageSlice';


class CompanyAddController extends React.Component {
	constructor(props) {
		super(props);
		this.state = {error: null,isLoaded: false,company: new CompanyModel(), validation: false};
		
	}

	async componentDidMount() {
		var {company} = this.state;
		const { companyid, dispatch, navigate } = this.props;
/*
		if ("geolocation" in navigator) {
			const options = {
				enableHighAccuracy: false,
				timeout: 5000,
				maximumAge: 0,
			};

			navigator.geolocation.getCurrentPosition(this.success.bind(this), this.error.bind(this), options);

		} else {
			console.log("Not Available");
		}
*/
		if(companyid) {
			try {
				let mobileButton = (
					<>
					<div className="d-flex">
						<a href="#" onClick={this.mobileBackButtonHandler} variant="primary"  className="back btn-circle">
							<svg xmlns="http://www.w3.org/2000/svg" id="Bold" viewBox="0 0 24 24">
								<path d="M17.921,1.505a1.5,1.5,0,0,1-.44,1.06L9.809,10.237a2.5,2.5,0,0,0,0,3.536l7.662,7.662a1.5,1.5,0,0,1-2.121,2.121L7.688,15.9a5.506,5.506,0,0,1,0-7.779L15.36.444a1.5,1.5,0,0,1,2.561,1.061Z"></path>
							</svg>
						</a>
						<a href="#" onClick={this.mobileButtonClickHandler} className="btn-circle">
							<svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24">
								<path d="M12,10a4,4,0,1,0,4,4A4,4,0,0,0,12,10Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,16Z"/><path d="M22.536,4.122,19.878,1.464A4.966,4.966,0,0,0,16.343,0H5A5.006,5.006,0,0,0,0,5V19a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V7.657A4.966,4.966,0,0,0,22.536,4.122ZM17,2.08V3a3,3,0,0,1-3,3H10A3,3,0,0,1,7,3V2h9.343A2.953,2.953,0,0,1,17,2.08ZM22,19a3,3,0,0,1-3,3H5a3,3,0,0,1-3-3V5A3,3,0,0,1,5,2V3a5.006,5.006,0,0,0,5,5h4a4.991,4.991,0,0,0,4.962-4.624l2.16,2.16A3.02,3.02,0,0,1,22,7.657Z"/>
							</svg>
						</a>
					</div>
					</>
);
				
				dispatch(showLoader(true, mobileButton));
				var response = await Company.getCompany(companyid);
				company.addData(response.data);
				this.setState({company: company});
				console.log("response", response.data);
				dispatch(hideLoader());
			} catch(err) {
				if(err.response.status == 403) {
					dispatch({ type: MESSAGE_ERROR, "message": "U bent geen eigenaar van het bedrijf welke u probeert op te vragen", "header": "Rechten" });
					navigate('/company');
				} else {
					dispatch({ type: MESSAGE_ERROR, "message": "Onbekende fout", "header": "Bedrijfgegevens ophalen" });
				}
				dispatch(hideLoader());
			}
		}
	}
	
	mobileBackButtonHandler= (event) => {
		event.preventDefault();
		this.props.navigate('/company');
	}
	
	mobileButtonClickHandler= (event) => {
		event.preventDefault();
		const {company} = this.state;
		this.onSaveHandler(company);
	}
	
	onSaveHandler = (data) => {
		const { dispatch, companyid, user } = this.props;
		const {company} = this.state;
		dispatch(showLoader());
		company.addData(data);
		var companyPromise;
		if( !companyid ) {
			companyPromise = Company.create(company.getData());
		} else {
			companyPromise = Company.update(companyid, company.getData(false));
		}

		companyPromise
			.then((response) =>   {
			dispatch({ type: MESSAGE_SUCCES, "message": "De gegevens zijn opgeslagen!", "header": "Succes" });
			dispatch(hideLoader());
			dispatch(messageSlice.actions.submitMessage({action: SET_COMPANY, payload: { company : response.data.data }}));
			//this.props.navigate('/company');
		})
		.catch((err) => {
			if(err.response.status == 422) {
				this.setState({validation: err.response.data.data});
				dispatch({ type: MESSAGE_INFO, "message": "In het formulier zijn validatie fouten gevonden!", "header": "Validatie fouten" });
			}
			dispatch(hideLoader());
		});		
		//this.c++;
		//const { dispatch } = this.props;
			//dispatch({ type: MESSAGE_ERROR, "message": "Succes "+this.c, "header": "Info header" });
//		let navigate = useNavigate();
//		navigate('/');
			
	}

	render() {
		
		
		const {company, validation } = this.state;
	return <CompanyAdd initData={company} onSave={this.onSaveHandler} validation={validation}/>;
	}

}

const CompanyAddInit = (props) => {
	let { id } = useParams();
	let navigate = useNavigate();
	return (<CompanyAddController {...props} companyid={id} navigate={navigate} />)
}

function mapStateToProps(state) {
  const { isLoggedIn, user } = state.auth;
  return {
    isLoggedIn,
    user
  };
}

//export default (ProductAdd);

export default connect(mapStateToProps)(CompanyAddInit);